import { formatHtml } from "@trumpf/ux.common-storybook";
import { Template } from "./page-body.templates";

export default {
    title: "Salesforce/Components/Page Body",
    component: "ux-iws-sf-page-body",
    render: Template.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    argTypes: {
        _slot: {
            control: { type: "text" },
        },
    },
    args: {
        _slot: `Content of the page.`,
    },
};

export const Default = {};
